/// <reference path="../typings/index.d.ts" />
String.prototype.format = function() {
    var args = arguments;
    return this.replace(/\{\{|\}\}|\{(\d+)\}/g, function(m, n) {
        if (m === "{{") {
            return "{";
        }
        if (m === "}}") {
            return "}";
        }
        return args[n];
    });
};

function init_social_media_feed(event_id, count, max_displayed_posts_per_column) {
    get_event_posts(event_id, count, max_displayed_posts_per_column);
    setInterval(function() {
        get_event_posts(event_id, count, max_displayed_posts_per_column);
    }, 10000);
    get_event_sponsor_posts(event_id);
    setInterval(function() {
        get_event_sponsor_posts(event_id);
    }, 30000);
}

function get_event_posts(event_id, count, max_displayed_posts_per_column) {
    // enable_loading_div(); 
    var post_count = count;
    var current_posts_string = get_current_posts();
    $.ajax({
            type: "GET",
            dataType: "json",
            async: true,
            url: "/api.php/events/" + event_id + "/posts",
            data: { count: post_count, current_post_ids: current_posts_string }
        })
        .done(function(data) {
            if (data.length !== 0) {
                render_event(data, max_displayed_posts_per_column);
            }
        })
        .fail(function() {
            console.log("Ajax to retreive posts failed.");
        });
}

function get_event_sponsor_posts(event_id, count, max_displayed_posts_per_column) {
    var post_count = count;
    var current_posts_string = get_current_posts();
    $.ajax({
            type: "GET",
            dataType: "json",
            async: true,
            url: "/api.php/events/" + event_id + "/sponsored_posts"
        })
        .done(function(data) {
            if (data.length !== 0) {
                render_sponsored_post(data);
            }
        })
        .fail(function() {
            console.log("Ajax to retreive posts failed.");
        });
}

function get_current_posts() {
    var current_post_ids = [];
    var social_media_posts = $("#social-media-wrapper").find("div[id^=social-post-]");
    social_media_posts.each(function() {
        var current_post_id = $(this).attr("id");
        current_post_id = current_post_id.replace("social-post-", "");
        current_post_ids.push(current_post_id);
    });
    return current_post_ids.toString();
}

function render_event(data, max_displayed_posts_per_column) {
    // this can be extended to also render event data instead of only the posts
    jQuery.each(data.posts, function(i, val) {
        var source = $("#post-template-" + val.source).html();
        if (source !== undefined) {
            var template = Handlebars.compile(source);
            var count = 0;
            var existing_element = $("#social-post-" + val.id);
            if (existing_element.length === 0) {
                var html = render_post(val, template);
                var shortest_column = determine_shortest_column(".social-media-column");
                output_post(shortest_column, html);
            }
        }
    });
    disable_old_posts(max_displayed_posts_per_column);
    enable_new_posts();
}

function render_sponsored_post(data, max_displayed_posts_per_column) {
    // this can be extended to also render event data instead of only the posts
    var source = $("#post-template-sponsored").html();
    if (source !== undefined) {
        var template = Handlebars.compile(source);
        var html = render_post(data, template);
        var shortest_column = determine_shortest_column(".social-media-column");
        output_post(shortest_column, html);
        disable_old_posts(max_displayed_posts_per_column);
        enable_new_posts();
    }
}

function render_post(post, template) {
    var context = post;
    return template(context);
}

function output_post($wrapper, html) {
    $(html).prependTo($wrapper);
}

function disable_old_posts(max_displayed_posts_per_column) {
    var social_media_post_columns = $(".social-media-column");
    social_media_post_columns.each(function() {
        var social_media_posts = $(this).find(".social-post");
        var current_count = social_media_posts.length;
        if (current_count > max_displayed_posts_per_column) {
            var hide_this_many_posts = max_displayed_posts_per_column - current_count;
            var old_posts = social_media_posts.slice(hide_this_many_posts);
            old_posts.each(function() {
                $(this).addClass("disabled");
            });
        }
    });
}

function enable_new_posts() {
    var new_social_media_posts = $("#social-media-wrapper").find(".social-post.new");
    new_social_media_posts.each(function() {
        $(this).removeClass("new"); // .css("max-height","1000px");
    });
}

function enable_loading_div() {
    $("#social-media-wrapper").slideUp(100);
    $("#social-media-loading-div").slideDown(500);
}

function disable_loading_div() {
    $("#social-media-loading-div").slideUp(100);
    $("#social-media-wrapper").slideDown(500);
}

function determine_shortest_column(social_column_class) {
    var all_columns = $(social_column_class);
    var minimumHeight = null;
    var minimumColumn = null;
    all_columns.each(function() {
        var columnHeight = 0;
        $(this).children("div.social-post").each(function(i, elem) {
            columnHeight += $(elem).height();
        });
        if (minimumHeight === null || columnHeight < minimumHeight) {
            minimumColumn = $(this);
            minimumHeight = columnHeight;
        }
    });
    return minimumColumn;
}
// setting up foundation
$(document).foundation();